export default {
    changeUrl(new_url,old_url = undefined, title){
        if(old_url){
            window.history.pushState({},"", new_url);
            window.dispatchEvent(new Event('popstate'));
        }
    },
    functionByParams(){

    },
    getSearchParams(){
        return new URLSearchParams(new URL(this.getCurrentUrl()).search);
    },
    getCurrentUrl(){
        return window.location.href
    }
}